// extracted by mini-css-extract-plugin
module.exports = {"varPageFadeTDur":"175ms","varPageSlideTDur":"500ms","varSidebarTDur":"350ms","scene":"scene-module__scene___3EKgj"};